var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97745 3.31107C5.36333 3.49407 3.29948 5.67269 3.29948 8.33335C3.29948 11.1139 5.5536 13.3681 8.3342 13.3681C10.5619 13.3681 12.452 11.921 13.1153 9.91576C12.6048 10.1266 12.0454 10.2431 11.4592 10.2431C9.06213 10.2431 7.11892 8.29986 7.11892 5.90279C7.11892 4.93116 7.43845 4.0341 7.97745 3.31107ZM2.25781 8.33335C2.25781 4.97745 4.9783 2.25696 8.3342 2.25696C8.64644 2.25696 8.95349 2.28055 9.25361 2.32614C9.46122 2.35767 9.62959 2.5108 9.68062 2.7145C9.73165 2.9182 9.65536 3.13262 9.48713 3.25831C8.68089 3.86067 8.16059 4.8209 8.16059 5.90279C8.16059 7.72456 9.63743 9.2014 11.4592 9.2014C12.2469 9.2014 12.9688 8.92598 13.536 8.46574C13.699 8.33348 13.9254 8.31198 14.1103 8.41119C14.2953 8.51041 14.4026 8.71095 14.3826 8.91988C14.0872 12.0008 11.4923 14.4097 8.3342 14.4097C4.9783 14.4097 2.25781 11.6892 2.25781 8.33335Z",
    fill: "#currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.17ba114e1fb821830eb3cf660b207766.svg";
export { ForwardRef as ReactComponent };